module.exports = __webpack_public_path__ + "img/chair_hot_on_border.270aa7ed.png";